import { render } from "./NemBody.vue?vue&type=template&id=a05a4706"
import script from "./NemBody.vue?vue&type=script&lang=js"
export * from "./NemBody.vue?vue&type=script&lang=js"

import "./NemBody.vue?vue&type=style&index=0&id=a05a4706&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__